import type { Request } from '@zimpel/common/newApi';
import api from '@zimpel/common/newApi';

type OptOutResponse = {
  isPrivateSource: boolean
}
// eslint-disable-next-line import/prefer-default-export
export const optOut: Request<{ token: string }, OptOutResponse> = async ({ token }) => api.post(`/api/opt_out/${token}`);
